var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProgressTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #546f7b;\r\n      }\r\n\r\n      .cls-3 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #dce0e2;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 159.3,
    cy: -61.8,
    r: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.8-65.6h0l-1.9,1.3c-.1,0-.2,0-.2-.1v-1.8c0-.1,0-.2.1-.3l2-1.4c0,0,.2-.1.3-.1h1.5c.1,0,.2,0,.2.2v11.9c0,.1,0,.2-.2.2h-1.7c-.1,0-.2,0-.2-.2v-9.7Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4-2",
    "data-name": "Ellipse_4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 159.3,
    cy: 129.2,
    r: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4-2",
    "data-name": "_4",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.2,133.1v-1.4c0,0,0-.2,0-.2l4-8.4c0-.1.1-.1.3-.1h1.7c.1,0,.2,0,.1.2l-3.9,8.4h0s2.8,0,2.8,0c0,0,.1,0,.1-.1v-3.1c0-.1,0-.2.2-.2h1.7c.1,0,.2,0,.2.2v3.1c0,0,0,.1.1.1h.9c.1,0,.2,0,.2.2v1.4c0,.1,0,.2-.2.2h-.9c0,0-.1,0-.1.1v1.6c0,.1,0,.2-.2.2h-1.7c-.1,0-.2,0-.2-.2v-1.6c0,0,0-.1-.1-.1h-4.8c-.1,0-.2,0-.2-.2Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4-3",
    "data-name": "Ellipse_4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 159.3,
    cy: 75.2,
    r: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4-3",
    "data-name": "_4",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.6,78.5l1.6-.4c0,0,.2,0,.2.1.3.7.8,1.3,1.9,1.3s1.8-.8,1.8-1.8-.8-2-2-2h-.5c-.1,0-.2,0-.2-.2v-1.4c0-.1,0-.2.2-.2h.5c1.1,0,1.8-.7,1.8-1.8s-.6-1.7-1.6-1.7-1.4.5-1.6,1.3c0,.1-.1.1-.2.1l-1.5-.4c-.1,0-.2-.1-.1-.2.3-1.5,1.6-2.6,3.6-2.6s3.6,1.4,3.6,3.4-.5,1.9-1.4,2.5h0c.7.3,1.6,1.4,1.6,3s-1.6,3.7-3.8,3.7-3.4-1-3.8-2.6c0-.1,0-.2.1-.2Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4-4",
    "data-name": "Ellipse_4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 159.3,
    cy: 4.2,
    r: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4-4",
    "data-name": "_4",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.6,8.7c0-.1,0-.2,0-.2l4.3-5.4c.5-.6.8-1.2.8-1.9s-.6-1.6-1.6-1.6-1.5.6-1.7,1.5c0,.1,0,.2-.2.1l-1.6-.3c-.1,0-.2-.1-.1-.2.2-1.4,1.3-2.9,3.6-2.9s3.6,1.5,3.6,3.4-.4,2-1.2,2.9l-3.6,4.3h0s4.5,0,4.5,0c.1,0,.2,0,.2.2v1.4c0,.1,0,.2-.2.2h-6.9c-.1,0-.2,0-.2-.2v-1.4Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 25,
    cy: 25,
    r: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.1,30.6c-.3,0-.5,0-.7-.3l-5.2-5.2c-.4-.4-.4-1,0-1.4s1-.4,1.4,0l4.5,4.5,8.8-8.8c.4-.4,1-.4,1.4,0s.4,1,0,1.4l-9.5,9.5c-.2.2-.5.3-.7.3Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-5",
    "data-name": "Ellipse_4",
    className: "cls-4",
    cx: 242.8,
    cy: -62.2,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-6",
    "data-name": "Ellipse_4",
    className: "cls-2",
    cx: 313.8,
    cy: -62.2,
    r: 15
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgressTick);
export default __webpack_public_path__ + "static/media/icon-progress-tick.ee219c9265f00a260dbf13abf143f7c0.svg";
export { ForwardRef as ReactComponent };